import { supabase } from './client';

export async function getCurrentUserProfile() {
  if (!supabase) {
    return {
      user: null,
      error: new Error('Supabase is not configured.')
    };
  }

  const { data, error } = await supabase.auth.getUser();

  if (error && import.meta.env.DEV) {
    console.error('Supabase current-user check failed:', error);
  }

  return {
    user: data.user,
    error
  };
}